import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AboutSection from "../../components/about-section/about-section.component";
import FeaturedPropertiesSlider from "../../components/featured-properties-slider/featured-properties-slider.component";
import HeroSlider from "../../components/hero-slider/hero-slider.component";
import { API_URL } from "../../shared/constant";

import "./home.styles.scss";

const Home = () => {
  const [pageData, setPageData] = useState(null);
  const getPageData = () => {
    axios.get(API_URL.CMS.HOME).then(
      (res) => {
        if (res.data.code === 200) {
          setPageData(res.data.data);
        }
      },
      (error) => {}
    );
  };
  useEffect(() => {
    getPageData();
  }, []);
  return (
    <Fragment>
      {pageData ? (
        <HeroSlider slides={pageData && pageData.slide ? pageData.slide : []} />
      ) : null}
      <AboutSection pageData={pageData} />
      <FeaturedPropertiesSlider pageData={pageData} />
      <Outlet />
    </Fragment>
  );
};

export default Home;
